/* eslint no-unused-vars: off, @typescript-eslint/no-unused-vars: off */
/**
 * User Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.3.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    ProjectIdsAll,
} from './';

/**
 * @export
 * @interface ApiKeyCreate
 */
export interface ApiKeyCreate {
    /**
     * @type {string}
     * @memberof ApiKeyCreate
     */
    name: string;
    /**
     * @type {ProjectIdsAll | Array}
     * @memberof ApiKeyCreate
     */
    project_ids: ProjectIdsAll | Array<number>;
    /**
     * @type {number}
     * @memberof ApiKeyCreate
     */
    permission_id?: number;
}
